import { purgeNotes } from './notes.js';
import { purgeDeck } from './decks.js';

export const TRASH_RETENTION_MS = 30 * 24 * 3600 * 1000;

/** Erase content of items that have been in the trash longer than the retention window. */
export async function purgeExpired(db, now = Date.now()) {
  const cutoff = now - TRASH_RETENTION_MS;
  const notes = (await db.notes.toArray()).filter((n) => n.deletedAt && !n.purged && n.deletedAt < cutoff);
  if (notes.length) await purgeNotes(db, notes.map((n) => n.id));
  const decks = (await db.decks.toArray()).filter((d) => d.deletedAt && !d.purged && d.deletedAt < cutoff);
  for (const d of decks) await purgeDeck(db, d.id);
  return notes.length + decks.length;
}
